import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Cruzeiro ao Pôr-do-Sol em Vilamoura · Iate Privado · Morningstar";
const DESC = "Cruzeiro privado ao pôr-do-sol em Vilamoura no iate Morningstar — duas horas ao entardecer com espumante, tapas portuguesas e a costa do Algarve em luz dourada.";
const PATH = "/pt/cruzeiro-por-do-sol-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.sunsetCruiseVilamoura;

export const Route = createFileRoute("/pt/cruzeiro-por-do-sol-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Cruzeiro ao Pôr-do-Sol · Vilamoura · Algarve",
        title: "Cruzeiro ao pôr-do-sol em Vilamoura a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Uma viagem privada ao entardecer da Marina de Vilamoura até Olhos d'Água e às falésias da Falésia — espumante, tapas portuguesas e a luz dourada do Algarve.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Planear o meu pôr-do-sol",
      }}
      pageContent={CONTENT.pt}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "cruzeiro por do sol vilamoura, cruzeiro pôr do sol algarve, passeio pôr do sol vilamoura, sunset vilamoura",
      altPath: { en: "/sunset-cruise-vilamoura", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Vilamoura Sunset Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Cruzeiro Pôr-do-Sol Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.pt.faqs)) },
      ],
    }),
});
